
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgModule } from '@angular/core';
import { ConfiguracionDiscapacidadRoutingModule } from '../configuracion-discapacidad/configuracion-discapacidad-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { GenerarReporteRouting } from './generar-reporte-routing.module';
import { GenerarReporteComponent } from './generar-reporte.component';
import { GenerarReporteActivosFijosComponent } from './reporte-activos-fijos/generar-reporte-activos-fijos.component';
import { GenerarReporteInformeVisitanteComponent } from './reporte-informe-visitante/generar-reporte-informe-visitante.component';
import { ReporteInformeTotalIngresosComponent } from './reporte-informe-total-ingresos/reporte-informe-total-ingresos.component';
import { ReporteMedevacComponent } from './reporte-medevac/reporte-medevac.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}


@NgModule({
  declarations: [GenerarReporteComponent, GenerarReporteActivosFijosComponent,
    GenerarReporteInformeVisitanteComponent, ReporteInformeTotalIngresosComponent, ReporteMedevacComponent],
  imports: [
    GenerarReporteRouting,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    })
  ],
  entryComponents: []
})

export class GenerarReporteModule { }
